import map from 'lodash/map';
import union from 'lodash/union';
import { createSelector } from 'reselect';
import { getTransformEntities } from '../entities';

const getAllTransforms = (state) => state.transforms.allTransforms;
const getListing = (state) => state.transforms.listing;

export const getReusableTransformEntities = createSelector(
  [getAllTransforms, getTransformEntities],
  (allTransforms, entities) => {
    const { sortedIds, sortedPublicIds, decoded } = allTransforms;

    return map(union(sortedIds, sortedPublicIds), (id) => ({
      ...entities[id],
      decoded: decoded[id]?.decoded || null,
      codeLanguage: decoded[id]?.codeLanguage || 'json',
    }));
  },
);

export const getReusableTransformListingEntities = createSelector(
  [getListing, getAllTransforms, getTransformEntities],
  (listing, allTransforms, entities) => {
    const { decoded } = allTransforms;

    return map(listing, (id) => ({
      ...entities[id],
      decoded: decoded[id]?.decoded || null,
      codeLanguage: decoded[id]?.codeLanguage || 'json',
    }));
  },
);
